import { ColumnDef } from '@tanstack/react-table'
import { AdSupplier } from '@magnetar/admin-api-interfaces'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useViewModeActions } from '@/hooks/useViewModeActions'

export const columns: ColumnDef<AdSupplier>[] = [
  {
    accessorKey: 'supplier_id',
    header: 'ID',
    cell: ({ row }) => {
      const id: number = row.getValue('supplier_id')
      return (
        <Badge variant="outline" className="font-medium">
          {id}
        </Badge>
      )
    },
  },
  {
    accessorKey: 'supplier_name',
    header: '供應商名稱',
  },
  {
    accessorKey: 'manager',
    header: '負責人',
  },
  {
    accessorKey: 'phone',
    header: '電話',
  },
  {
    accessorKey: 'address',
    header: '地址',
  },
  {
    accessorKey: 'slots_per_hour',
    header: '梯次／時',
    cell: ({ row }) => {
      const slots = row.original.slots_per_hour
      return slots === null || slots === undefined ? (
        <span className="text-muted-foreground">未設</span>
      ) : (
        <span className="tabular-nums">{slots}</span>
      )
    },
  },
  {
    accessorKey: 'is_active',
    header: '狀態',
    cell: ({ row }) => {
      const is_active: boolean = row.getValue('is_active')
      return (
        <Badge variant={is_active ? 'default' : 'secondary'}>{is_active ? '啟用' : '停用'}</Badge>
      )
    },
  },
  {
    id: 'actions',
    cell: function ActionsCell({ row }) {
      const supplier = row.original
      const { setAdMode } = useViewModeActions()

      const handleEdit = () => {
        setAdMode(supplier.supplier_id)
      }

      return (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={handleEdit}>
            編輯供應商
          </Button>
        </div>
      )
    },
  },
]
